// extracted by mini-css-extract-plugin
export default {"ReactTags":"ReactTags_ReactTags__t4nzy"};